import { render } from "./Forums.vue?vue&type=template&id=5816c14c&scoped=true"
import script from "./Forums.vue?vue&type=script&lang=js"
export * from "./Forums.vue?vue&type=script&lang=js"

import "./Forums.vue?vue&type=style&index=0&id=5816c14c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5816c14c"]])

export default __exports__